<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">Example Component</div>

          <div class="card-body">
            I'm an example component showing random 10 products and showing you
            how to conenct blade with vue.

            <div class="my-5 flex">
              <div class="row">
                <div
                  class="col-md-3"
                  v-for="product in products"
                  :key="product.id"
                >
                  <div class="card">
                    <div class="card-header">
                      {{ product.title }}
                    </div>
                    <div class="card-body">
                      {{ product.slug }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["products"],
  data() {
    return {
      response: [],
    };
  },
  methods: {
    testApi() {
      axios.get("free-endpoint").then(({ data }) => {
        this.response = data;
      });
    },
  },
  mounted() {
    this.testApi();
  },
};
</script>
